import {promises} from "fs";
import {exec} from "../../electron/common/api";
import hdapi from "../common/hdapi";
import Converter, {ConverterStates} from "./Converter";
import {cutFile} from "../common/utils";
import {
	checkIsCompressOver,
	getTaskDownloadUrl,
	getTaskStatus,
	upload,
	uploadAll,
	uploadVerify,
} from "../plugins/sdk";
import {getNowTimestamp, getTimestamp, getUUID} from "../plugins/sdk/common/utils";
import ExceededWarn from "../pages/dialogs/ExceededWarn";

export default class ImageConverter extends Converter {
	constructor() {
		super();
		this.options = {
			compressLevel: 1, // 0: 缩小优先 1:清晰优先
			outputExt: "", // '':格式不变 png|jpg 其它格式
		};
		this._ysType = "PPT压缩";
		this._isExcededDolgOpen = false;
	}
	loadFile(path, isAFilePush, url) {
		// console.log("获取的word地址");
		return super.loadFile(path).then((file) => {
			// console.log("loadfile word =", res);
			if (isAFilePush) {
				file.isAFilePush = isAFilePush;
				file.OriginFilePushPath = url;
			}
			if (file.size) {
				file.state = ConverterStates.WAIT;
			} else {
				file.state = ConverterStates.BROKE_FILE;
			}
			return file;
		});
	}
	async doConvert(file, dir, i) {
		if (i == null) {
			i = "";
			file.filename = hdapi.filename(file.path);
		}
		// console.log("压缩第", i, "次");
		var ext = this.options.outputExt;
		var quality = this.options.compressLevel ? 1 : 2;
		// console.log("quality", quality);
		ext = ext ? "." + ext : hdapi.extname(file.path);
		if (i == "") {
			// console.log("nowFileArry_1", this.nowFileArry);
			if (this.nowFileArry.indexOf(file.filename) == -1) {
				this.nowFileArry.push(file.filename);
				// console.log("nowFileArry_2", this.nowFileArry);
			} else {
				var a = hdapi.extname(file.path).split(".");
				file.filename += `-` + a[1];
				this.checkIsSameFileName(file);
				// this.nowFileArry.push(file.filename);
				// console.log("nowFileArry_3", this.nowFileArry);
			}
			var outfile = file.filename + ext;
		} else {
			var b = file.filename + `-${i}`;
			this.nowFileArry.push(b);
			console.log("nowFileArry_4", this.nowFileArry);
			var outfile = b + ext;
		}
		// console.log("outfile", outfile);
		if (file.isAFilePush) {
			if (window.store.local.outputOriginDir) {
				file.outpath = hdapi.join(file.outputOriginDir, outfile);
			} else {
				file.outpath = hdapi.join(file.outputCustomDir, outfile);
			}
			// return;
		} else file.outpath = hdapi.join(dir, outfile);
		// console.log("file.outpath", file.outpath);
		let exist = await hdapi.exists(`${file.outpath}`);
		var compress_text;
		switch (this.options.compressLevel) {
			case 0:
				compress_text = "condense";
				break;
			case 1:
				compress_text = "clarity";
				break;
			case 2:
				compress_text = "normal";
				break;
		}
		if (exist) {
			await this.doConvert(file, dir, i == "" ? 1 : ++i);
		} else {
			// eslint-disable-next-line no-constant-condition
			if (hdapi.platform == "MAC" || !window.vue.$app.isNet) {
				file.onlineCompressStep = 0;
				file.CompressStyle = "online";
				file.isStopCompress = false;
				this.setTimeCheckProgress(file);
				var postdata = {
					tasktype: "pptcompress",
					limitsize: 2048,
					filename: hdapi.filename(file.path) + hdapi.extname(file.path),
					filecount: 1,
					isshare: 0,
					// timestamp: await getTimestamp(),
					softname: "CompressMagician",
					softversion: window.$softInfo.version,
					machineid: getUUID(),
					productid: 133,
					picturequality: compress_text, //清晰：clarity	常规：normal缩小：condense
					// outputfileextension: "jpg",
				};
				if (window.store.VIPlevel) {
					postdata.account = window.store.local.userLoginData.username;
					postdata.usertoken = window.store.local.userLoginData.usertoken;
				}
				// console.log("postdata", postdata);
				let res = await uploadVerify(postdata, file);
				if (res == "ExceedeTimes" && !this._isExcededDolgOpen) {
					// reject("exceededwarn")
					// debugger
					this._isExcededDolgOpen = true;
					let _this = this;
					await window.store.$dlg.show(ExceededWarn).then(() => {
						return Promise.reject("err");
					});
				}
				// console.log("请求上传文件权限获取成功", res);
				file.onlineCompressStep = 1;
				file.upload_data = res;
				file.chunksList = [];
				await cutFile(file, 2048000);
				file.onlineCompressStep = 2;
				console.log("切片结束返回");
				let b = await uploadAll(file, file.upload_data, 0);
				file.onlineCompressStep = 3;
				// console.log(res);
				if (b == "上传结束") {
					const c = await checkIsCompressOver(file);
					console.log("c", c);
				}
			} else if (hdapi.platform == "WIN") {
				var main_path = await hdapi.getPath("main");
				main_path = main_path.split("\\");
				main_path.splice(-1, 1);
				main_path = main_path.join("\\");
				// console.log("路径", `${main_path}\\bin\\comressfile\\output`);
				var ini_path = await hdapi
					.exists(`${main_path}\\bin\\compressfile`)
					.then((res) => {
						// console.log("是否有该路径", res);
						if (res) {
							file._outpath = `${main_path}\\bin\\compressfile\\output\\${hdapi.filename(
								file.path
							)}`;
							return `${main_path}\\bin\\compressfile\\output\\${hdapi.filename(
								file.path
							)}${ext}.ini`;
						} else {
							file._outpath = `${main_path}\\resources\\apps\\bin\\compressfile\\output\\${hdapi.filename(
								file.path
							)}`;
							return `${main_path}\\resources\\app\\bin\\compressfile\\output\\${hdapi.filename(
								file.path
							)}${ext}.ini`;
						}
					})
					.catch((err) => {
						console.log("查询路径出错", err);
					});
				console.log("wordini路径", ini_path);
				var handle_time = file.size / 1024 / 1024 < 10 ? 10 : 1e2;
				var handle = setInterval(function () {
					// console.log("是否监听到文件");
					hdapi
						.readFile(ini_path, "utf8")
						.then((text) => {
							// console.log("读取到的ini文件", text);
							var ss = text.split("\n");
							// if (ss == "") return;
							// console.log("ss", ss);
							if (ss[4] == undefined) var i = 1;
							else i = 4;
							var p = parseFloat(ss[i].split("=")[1] / 100);
							if (!isNaN(p)) {
								file.progress = p;
							}
						})
						.catch((err) => {
							console.log("读取文件遇到问题", err);
						});
				}, handle_time);
				// console.log("开始word压缩", `CompressFile "${file.path}" "${file.outpath}" ${quality}`);
				if (ext == ".pptx") {
					return hdapi
						.procCreate([`CompressFile`, file.path, file.outpath, quality], {spawnMode: true})
						.then((x) => {
							file._proc = x;
							return x.wait();
						})
						.finally(() => {
							// console.log("压缩结束");
							clearInterval(handle);
							hdapi.unlink(ini_path);
						});
				}
				if (ext == ".ppt") {
					clearInterval(handle);
					var docpath = file.path;
					var olfdocpath = file.path;
					docpath = docpath.split(".");
					docpath[docpath.length - 1] = "pptx";
					docpath = docpath.join(".");
					console.log("docpath", docpath);
					file._outpath = "";
					return hdapi
						.procCreate([`AsposeFormatChange`, file.path, `pptx`, docpath], {spawnMode: true})
						.then((x) => {
							file._proc = x;
							file.outpath = docpath;
							return x.wait();
						})
						.then(() => {
							file.path = docpath;
							return this.doConvert(file, dir).then(() => {
								hdapi.unlink(file.path);
								file.path = olfdocpath;
							});
						})
						.catch(() => {
							console.log("转换ppt出错");
						});
				}
			}
		}
	}
	setTimeCheckProgress(file) {
		file.nowInterval_step = file.onlineCompressStep;
		file.nowInterval_limit = 0.1;
		file.progress = 0;
		file.progress_time = setInterval(function () {
			// console.log("progress", file.progress);
			if (file.state != 2) {
				file.progress = 0;
				clearInterval(file.progress_time);
				return;
			}
			if (file.nowInterval_step != file.onlineCompressStep) {
				switch (file.onlineCompressStep) {
					case 0: {
						file.progress = 0;
						file.nowInterval_limit = 0.1;
						break;
					}
					case 1: {
						file.progress = 0.1;
						file.nowInterval_limit = 0.2;
						break;
					}
					case 2: {
						file.progress = 0.2;
						file.nowInterval_limit = 0.3;
						break;
					}
					case 3: {
						file.progress = 0.3;
						file.nowInterval_limit = 0.8;
						break;
					}
					case 4: {
						file.progress = 0.8;
						file.nowInterval_limit = 0.9;
						break;
					}
					case 5: {
						file.progress = 0.9;
						file.nowInterval_limit = 1;
						break;
					}
					case 6: {
						file.progress = 1;
						file.nowInterval_limit = 1;
						break;
					}
				}
				file.nowInterval_step = file.onlineCompressStep;
			}
			if (file.progress < 0.8 && file.progress < file.nowInterval_limit) file.progress += 0.01;
		}, 50);
	}

	checkIsSameFileName(file, i) {
		if (!i) i = 1;
		if (this.nowFileArry.indexOf(file.filename) == -1) {
			this.nowFileArry.push(file.filename);
			return;
		} else {
			file.filename = file.filename + `(${i})`;
			this.checkIsSameFileName(file, i);
		}
	}
}
